import { Banner } from "@shopify/polaris"
import React from "react"
import { useTranslation } from "react-i18next"

const ServiceNotAvailableBannerReportAtom = () => {
  const { t } = useTranslation()

  return (
    <Banner
      title={t("share:content.banners.service_not_available.title")}
      status="critical"
    >
      <p>{t("share:content.banners.service_not_available.body")}</p>
    </Banner>
  )
}

export default ServiceNotAvailableBannerReportAtom
